import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { getSite, updateSite } from '../../actions/SiteActions'
import { fetchTimezones } from '../../actions/TimezoneActions'
import { fetchSiteLoggingIntervals } from '../../actions/SiteLoggingIntervalActions'
import { fetchDataLoggerDevices } from '../../actions/DataLoggerDeviceActions'
import { fetchChildCompanies } from '../../actions/ChildCompanyActions'
import { fetchProbeTypes } from '../../actions/ProbeTypeActions'
import SiteContainer from '../../components/layout/SiteContainer'
import ContainerHeading from '../../components/layout/ContainerHeading'
import HelmetTitle from '../../components/layout/HelmetTitle'
import LoadingScreen from '../../components/LoadingScreen'
import SiteConfigForm from '../../components/forms/SiteConfigForm'
import styledTheme from '../../styles/theme'
import { H1 } from './styled-elements'


class Config extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
    }
  }

  resizeHandler = (e) => {
  }

  componentDidMount() {
    const { dispatch, match, apiAuth, timezones, siteLoggingIntervals, childCompanies } = this.props
    const { user } = apiAuth
    const companySlug = match.params.company_slug
    const siteSlug = match.params.site_slug
    dispatch(getSite(companySlug,siteSlug))
    !timezones.timezones.length && this.props.dispatch(fetchTimezones())
    !siteLoggingIntervals.siteLoggingIntervals.length && this.props.dispatch(fetchSiteLoggingIntervals())
    !childCompanies.childCompanies.length && this.props.dispatch(fetchChildCompanies(user.company_slug))
  }

  componentDidUpdate(prevProps) {
    const { dispatch, apiAuth, sites } = this.props
    const { user } = apiAuth
    const { site } = sites
    if (!site) return
    if (prevProps.sites.site && (prevProps.sites.site.id===site.id)) return
    const siteCompanySlug = site.company_slug
    this.props.dispatch(fetchProbeTypes(siteCompanySlug))
    this.props.dispatch(fetchDataLoggerDevices(siteCompanySlug))
  }

  isMobileView = () => {
    const screenWidth = window.innerWidth
    return (screenWidth < styledTheme.breakpoints.md)
  }

  updateDataLoggerDevices = (companySlug) => {
    this.props.dispatch(fetchDataLoggerDevices(companySlug))
  }

  configFormSubmitHandler = (submitParams) => {
    const { company_slug, slug } = submitParams
    this.props.dispatch(updateSite(company_slug,slug,submitParams))
  }

  renderForm = (props,state) => {
    console.log('props',props)
    return <div>
      <H1>Config</H1>
      <SiteConfigForm
        dispatch={props.dispatch}
        apiAuth={props.apiAuth}
        timezones={props.timezones}
        siteLoggingIntervals={props.siteLoggingIntervals}
        dataLoggerDevices={props.dataLoggerDevices}
        childCompanies={props.childCompanies}
        sites={props.sites}
        probeTypes={props.probeTypes}
        updateDataLoggerDevices={this.updateDataLoggerDevices}
        submitHandler={this.configFormSubmitHandler}
      />
    </div>
  }

  renderBody = (props,state) => <div>
    <LoadingScreen show={props.apiAuth.validating || (props.sites.fetching && !props.sites.sites.length)}/>
    {props.apiAuth.user && this.renderForm(props,state)}
  </div>

  render = () => <SiteContainer isSignedIn={this.props.apiAuth.isSignedIn}>
    <HelmetTitle title={`Config`} />
    {this.renderBody(this.props,this.state)}
  </SiteContainer>

}

export default connect(
  (store, props) => ({
    apiAuth: store.apiAuth,
    sites: store.sites,
    timezones: store.timezones,
    siteLoggingIntervals: store.siteLoggingIntervals,
    dataLoggerDevices: store.dataLoggerDevices,
    childCompanies: store.childCompanies,
    probeTypes: store.probeTypes,
  }),
)(Config)



// WEBPACK FOOTER //
// ./src/containers/sites/config.js